import React, { useEffect, useState } from 'react';
import { Badge, Button } from 'react-bootstrap';
import api from '../lib/api';

const OllamaStatusBadge = () => {
  const [status, setStatus] = useState('loading');

  const fetchStatus = async () => {
    try {
      const res = await api.get('/ollama-status/');
      setStatus(res?.data?.status || 'unknown');
    } catch (error) {
      setStatus('error');
    }
  };

  useEffect(() => {
    fetchStatus();
  }, []);

  const getBadgeVariant = () => {
    switch (status) {
      case 'online':
        return 'success';
      case 'unreachable':
      case 'error':
        return 'danger';
      case 'loading':
        return 'secondary';
      default:
        return 'warning';
    }
  };

  const getLabel = () => {
    switch (status) {
      case 'online':
        return 'Ollama Online';
      case 'unreachable':
        return 'Ollama Offline';
      case 'error':
        return 'Ollama Error';
      case 'loading':
        return 'Checking...';
      default:
        return 'Unknown';
    }
  };

  return (
    <div className="d-flex align-items-center gap-2 flex-wrap">
      <Badge bg={getBadgeVariant()} className="px-3 py-2 rounded-pill">
        {getLabel()}
      </Badge>
      <Button
        size="sm"
        variant="outline-primary"
        onClick={fetchStatus}
        className="admin-action-btn"
      >
        Refresh
      </Button>
    </div>
  );
};

export default OllamaStatusBadge;
